import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DashboardCard from 'components/molecules/Cards/DashboardCard/DashboardCard';

const StyledDealflowDashboardCard = styled(DashboardCard)`
  &.DealflowDashboardCard {
    display: flex;
    flex-direction: column;
    
    .DashboardCard {
      &-content {
        height: 100%;
        padding: ${props => props.theme.spacing(2)};
        overflow: hidden;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledDealflowDashboardCard.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowDashboardCard;
